import { render, staticRenderFns } from "./Capitalize.vue?vue&type=template&id=6cfbcec2&"
import script from "./Capitalize.vue?vue&type=script&lang=js&"
export * from "./Capitalize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports